export const card = {
  borderRadius: 'l',
  border: 'none',
  p: 'm',
  bg: 'secondary/background',
  overflow: 'hidden',
  variants: {
    shadow: {
      boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.16)',
    },
    disabled: {
      pointerEvents: 'none',
      opacity: 0.4,
    },
    movement: {
      bg: 'white',
      p: 'l',
      borderRadius: 's',
      shadow: 'soft',
    },
  },
};
